export const grant_type = "password";
export const client_id =
  "3MVG9qQjGkWUbcrEPx0UB_Dt_8OiIw_9bCAlmY9FkeVce56T_NRPWWzBnBVAMBo8sC70j9eVIc7rhCIvbJtlW";
export const client_secret = "8510413236952768843";
export const username = "chris-blwc@force.com.dev";
export const password = "SFpinaccess2019";
export const response_type = "token";
export const redirect_uri = "http://boltconcierge-2f0f9.firebaseapp.com";
export const scope = "refresh_token full";
export const display = "touch";



// WEBPACK FOOTER //
// ./src/Utils/Constants.js